import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ContentContainerComponent } from '../../ui/content-container/content-container.component';
import { EmptyStateComponent } from '../../ui/empty-state/empty-state.component';
import { InlineAlertComponent } from '../../ui/inline-alert/inline-alert.component';
import { PanelBodyComponent } from '../../ui/panel-body/panel-body.component';
import { InterestedPartiesListComponent } from '../../interested-parties-list/interested-parties-list.component';
import { InterestedPartiesExportButtonComponent } from '../../interested-parties-export-button/interested-parties-export-button.component';
import { TripInterestService } from '../../../services/trip-interest.service';

@Component({
  selector: 'app-interested-parties',
  imports: [
    TranslocoDirective,
    ContentContainerComponent,
    EmptyStateComponent,
    InlineAlertComponent,
    PanelBodyComponent,
    InterestedPartiesListComponent,
    InterestedPartiesExportButtonComponent,
  ],
  templateUrl: './interested-parties.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterestedPartiesComponent {
  private readonly tripInterest = inject(TripInterestService);

  readonly loading = computed(() => this.tripInterest.parties.isLoading());
  readonly loadError = computed(() => this.tripInterest.parties.error());
  // value() throws while the resource is in its error state, so check hasValue() first.
  readonly hasParties = computed(
    () => this.tripInterest.parties.hasValue() && this.tripInterest.parties.value().length > 0,
  );
}
